import React from "react";

const SideBar = (props) => {
  const { faqsData, showSidebarMenu, isSidebarManu } = props;

  return (
    <div className="support_sidebar">
      <div>
        <div className="sidebar_content">
          <div
            className="sidebar_content_head"
            onClick={() =>
              showSidebarMenu({
                tabId: "",
                isPartners: false,
                isIndividuals: !isSidebarManu.isIndividuals,
              })
            }
          >
            <h4>For Individuals</h4>
            <span>
              <i
                className={
                  isSidebarManu.isIndividuals
                    ? "edel-icon-sort-1"
                    : "edel-icon-sort-2"
                }
              ></i>
            </span>
          </div>
          {isSidebarManu && isSidebarManu.isIndividuals ? (
            <ul>
              {faqsData &&
                faqsData.clntFaq &&
                faqsData.clntFaq.tabList.length > 0 &&
                faqsData.clntFaq.tabList.map((list) => {
                  return (
                    <li
                      className={
                        isSidebarManu.tabId === list.id ? "active" : ""
                      }
                      key={list.id}
                      onClick={() =>
                        showSidebarMenu({ ...isSidebarManu, tabId: list.id })
                      }
                    >
                      <span>{list.tabName}</span>
                    </li>
                  );
                })}
            </ul>
          ) : null}
        </div>
        <div className="sidebar_content">
          <div
            className="sidebar_content_head"
            onClick={() =>
              showSidebarMenu({
                isIndividuals: false,
                tabId: "",
                isPartners: !isSidebarManu.isPartners,
              })
            }
          >
            <h4>For Partners</h4>
            <span>
              <i
                className={
                  isSidebarManu.isPartners
                    ? "edel-icon-sort-1"
                    : "edel-icon-sort-2"
                }
              ></i>
            </span>
          </div>
          {isSidebarManu && isSidebarManu.isPartners ? (
            <ul>
              {faqsData &&
                faqsData.vndFaq &&
                faqsData.vndFaq.tabList &&
                faqsData.vndFaq.tabList.length > 0 &&
                faqsData.vndFaq.tabList.map((list) => {
                  return (
                    <li
                      className={
                        isSidebarManu.tabId === list.id ? "active" : ""
                      }
                      key={list.id}
                      onClick={() => {
                        showSidebarMenu({ ...isSidebarManu, tabId: list.id });
                      }}
                    >
                      <span>{list.tabName}</span>
                    </li>
                  );
                })}
            </ul>
          ) : null}
        </div>
      </div>
    </div>
  );
};

export default SideBar;
